import BaseAction from '../../base-action'
import { fetchContentIfNeeded } from '../../content'
import { HttpMethod } from '../../../services/core'

const resource = 'offers'
const verb = HttpMethod.GET

export default class OspreyOffersImportStatus extends BaseAction {
    constructor(dataKey) {
        const id = 'ec59e0d3-4d98-46ff-b3ef-fba98c5b2523'
        const path = `/${resource}`
        super(resource, verb, path, id, dataKey)
        this.noCache = true
    }

    getOfferImportStatus(params) {
        this.path = `/${resource}/import`
        this.params = params

        return fetchContentIfNeeded(this)
    }
}



// WEBPACK FOOTER //
// src/actions/osprey-api/offers/offers-import-status.js